import { FC, useState } from 'react'
import { Button } from '../components/button/Button'
import { useLoadAudioFileFromUrl } from '../upload/hooks/useLoadAudioFileFromUrl'
import './LandingHeroTestButton.scss'
import { logger } from '../logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import toast from 'react-hot-toast'
import { CDN_URL } from '../constants'

const url = `${CDN_URL}/sounds/funky-boogie-brothers-the-little-big-beat-track.mp3`

export const LandingHeroTestButton: FC = () => {
  const loadAudioFileFromUrl = useLoadAudioFileFromUrl()
  const [loading, setLoading] = useState(false)

  return (
    <Button
      className="LandingHeroTestButton"
      onClick={() => {
        logger.log(LogActionType.LandingTestFileButtonClick)

        const toastId = toast.loading('Loading the test audio file')

        setLoading(true)
        loadAudioFileFromUrl(url).finally(() => {
          toast.dismiss(toastId)

          setLoading(false)
        })
      }}
      disabled={loading}
    >
      {loading ? 'Loading...' : 'Try it on a test file'}
    </Button>
  )
}
